$(document).on('change', '#cars_filter input, #cars_filter select', function(e){
  var form = $(this.closest('form'));

  Turbolinks.visit(form.attr('action') + '?' + form.serialize());
});
